import { StyledMainSection } from "@/styles/global";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Wrapper = styled.div`
  padding: 40px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 88px 0;
  }
`;

const Container = styled.div`
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0px 16px;
  padding-top: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 1512px;
    padding: 0 88px;
    padding-top: 32px;
    margin: auto;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: max-content;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 32px;
    width: unset;
  }
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 330px;
  width: 342px;
  max-width: 80vw;
  border-radius: 21px;
  -webkit-border-radius: 21px;
  -moz-border-radius: 21px;
  transform: translateZ(0);
  scroll-snap-align: start;
  aspect-ratio: 316 / 406;

  //gradient from bottom to top
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.black}00 50%,
      ${({ theme }) => theme.colors.black}99 100%
    );
    z-index: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  z-index: 2;
  padding: 16px;
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 32px 24px;
  }
`;

const NamePositionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Overlay = styled.div<{ $active?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 21px;
  z-index: 1;

  transition: backdrop-filter 0.2s ease-in-out;

  backdrop-filter: ${({ $active }) => ($active ? "blur(12px)" : "none")};
  background: ${({ $active, theme }) =>
    $active
      ? "rgba(0, 0, 0, 0.35)"
      : `linear-gradient(
    180deg,
    ${theme.colors.black}00 0%,
    ${theme.colors.black}38 60%
  )`};
`;

const IconWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
`;

const IconLink = styled.a`
  color: ${({ theme }) => theme.colors.white};

  svg {
    height: 24px;
    fill: ${({ theme }) => theme.colors.white};
    vertical-align: middle;
  }
`;

const S = {
  Section,
  Container,
  TextWrapper,
  NamePositionWrapper,
  CardWrapper,
  Card,
  Wrapper,
  Overlay,
  IconWrapper,
  IconLink,
};

export default S;
